"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvoiceStatus = void 0;

var common_1 = require("./common");

var InvoiceStatus;

(function (InvoiceStatus) {
  InvoiceStatus["DRAFT"] = "draft";
  InvoiceStatus["SENT"] = "sent";
  InvoiceStatus["PENDING"] = "pending";
  InvoiceStatus["OVERDUE"] = "overdue";
  InvoiceStatus["PAID"] = "paid";
  InvoiceStatus["REJECTED"] = "rejected";
  InvoiceStatus["CANCELLED"] = "cancelled";
  InvoiceStatus["REFUND_STARTED"] = "refund_started";
  InvoiceStatus["REFUND_REJECTED"] = "refund_rejected";
  InvoiceStatus["REFUNDED"] = "refunded";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));